// externals
import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// store
import * as pushToFIActionCreators from '@makemydeal/dr-dash-store/actions/pushToFIActionCreators';
import * as pushToFISelectors from '@makemydeal/dr-dash-store/selectors/pushToFISelectors';

// types
import { PushToFIStatus, type PushToFIProvider, type StateTree } from '@makemydeal/dr-dash-types';

// internal
import FIModalLoading from './FIModalLoading';
import { useInterval } from '../pushToRouteOne/useInterval';

export interface IPushToFIModalProps {
    provider: PushToFIProvider;
    header: JSX.Element;
}

const PushToFIModal = (props: IPushToFIModalProps) => {
    const { provider, header } = props;
    const dispatch = useDispatch();

    const status =
        useSelector((state: StateTree) => pushToFISelectors.getPushToFIStatus(state, provider.targetPlatformId))?.status ??
        PushToFIStatus.Ready;

    const [slow, setSlow] = useState(false);

    useInterval(() => setSlow(true), provider.slowTimeoutMs, status === PushToFIStatus.Waiting);

    useEffect(() => {
        if (status !== PushToFIStatus.Waiting) setSlow(false);
    }, [status]);

    if (status === PushToFIStatus.Ready) return null;

    // istanbul ignore next — thin wrapper around the action creator (CLEAR_PUSH_TO_FI_CACHE is exhaustively tested in the reducer)
    const onHide = () => dispatch(pushToFIActionCreators.clearPushToFICache(provider.targetPlatformId));

    return (
        <FIModalLoading
            provider={provider}
            header={header}
            onHide={onHide}
            slow={slow}
            success={status === PushToFIStatus.Success}
            error={status === PushToFIStatus.Failure}
            saveOfferError={status === PushToFIStatus.OfferSaveFailure}
        />
    );
};

export default PushToFIModal;
